import React, { useState, useEffect, useMemo } from 'react';
import TableModule from '../../components/TableModule';
import SuccessNotification from '../../components/Notifications/SuccessNotification';
import ErrorNotification from '../../components/Notifications/ErrorNotification';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardCheck, faXmark, faCheck,  faSearch } from '@fortawesome/free-solid-svg-icons';
import { useCallback } from 'react';
import apiClient from "../../axios";

const PermissionsModal = ({ message, isVisible, onClose, rol }) => {
    const [data, setData] = useState([]);
    const [selectedModules, setSelectedModules] = useState([]);
    const [rolPermissions, setRolPermissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const itemsPerPage = 10;
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    //const [search, setSearch] = useState('');
    const [searchInput, setSearchInput] = useState("");
    const [searchTerm, setSearchTerm] = useState("");

    const fetchAllData = useCallback(async () => { //page = 1
        try {
            setLoading(true);
            //const response = await apiClient.get(`/admin/permissions?page=${page}`);
            const response = await apiClient.get(`/admin/permissions`);
            let fetchedData = [];
            if (Array.isArray(response.data)) {
                fetchedData = response.data;
            } else {
                fetchedData = [response.data];
            }

            // Reordenar los datos para que los seleccionados aparezcan primero
            const reorderedData = fetchedData.sort((a, b) => {
                const aSelected = selectedModules.includes(a.code);
                const bSelected = selectedModules.includes(b.code);
                return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
            });

            setData(reorderedData);
            setTotalItems(response.data.length);
        } catch (error) {
            setIsErrorVisible(true);
        } finally {
            setIsSuccessVisible(true);
            setLoading(false);
        }
    }, [selectedModules]);

    const handleSave = async () => {
        const toAssign = selectedModules.filter(code => !rolPermissions.includes(code));
        const toRevoke = rolPermissions.filter(code => !selectedModules.includes(code));
        
        const payload = {
            toAssign,
            toRevoke
        };

        try {
            await apiClient.post(`/admin/roles/${rol.id}/permissions`, payload);
            setIsSuccessVisible(true);
        } catch (error) {
            console.error("Error al guardar los permisos", error);
            setIsErrorVisible(true);
        } finally {
            onClose();
        }
    };

    const handleCheckboxChange = (code) => {
        setSelectedModules(prevSelected =>
            prevSelected.includes(code)
                ? prevSelected.filter(selectedCode => selectedCode !== code)
                : [...prevSelected, code]
        );
    };

    /*const handleSelectAll = () => {
        if (selectedModules.length === data.length) {
            setSelectedModules([]);
        } else {
            setSelectedModules(data.map(item => item.code));
        }
    };*/
    
    const handleSelectAll = () => {
        const pageCodes = currentPageData.map(item => item.code);
        const allSelected = pageCodes.every(code => selectedModules.includes(code));

        if (allSelected) {
            // Deselecciona solo los de esta página
            setSelectedModules(prev =>
                prev.filter(code => !pageCodes.includes(code))
            );
        } else {
            // Añade los de esta página, sin duplicar
            setSelectedModules(prev => {
                const newSelection = new Set([...prev, ...pageCodes]);
                return Array.from(newSelection);
            });
        }
    };

    const handleSearch = useCallback(async (term) => { //page = 1
        try {
            setLoading(true);
            if (term === '') {
                // si el término está vacío, volvemos al fetchAllData (con reordenado)
                await fetchAllData();
                return;
            } else {
                // Construir la URL con los query params
                const params = new URLSearchParams({ search: term });
                //const response = await apiClient.get(`/admin/permissions?${params.toString()}&page=${page}`);
                const response = await apiClient.get(`/admin/permissions?${params}`);

                if (Array.isArray(response.data)) {
                    setData(response.data); // Si es un array, lo dejamos tal cual
                } else {
                    setData([response.data]); // Si es un objeto, lo encapsulamos en un array
                }
                setTotalItems(response.data.length);   
            }
        } catch (error) {
            setIsErrorVisible(true);
        } finally {
            setLoading(false);
        }
    }, [fetchAllData]);

    useEffect(() => {
        if (rol.id) {
            const fetchRol = async () => {
                try {
                    const response = await apiClient.get(`/admin/roles/${rol.id}`);
                    const roleModules = response.data.permissions.map(permission => permission.code);
                    setSelectedModules(roleModules);
                    setRolPermissions(roleModules);
                } catch (error) {
                    console.error("Error al cargar el rol", error);
                }
            };
            fetchRol();
        }
    }, [rol.id]);

    const handleFresh = async () => {
        const term = searchInput.trim();
        setSearchTerm(term);
        handleSearch(term);
        setCurrentPage(1);
    };

    useEffect(() => {
        if (selectedModules.length === 0) {
            fetchAllData();
            return
        } else {
            handleSearch(searchTerm);
        }        
    }, [fetchAllData, handleSearch, searchTerm, selectedModules]);

    const currentPageData = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        return data.slice(start, end);
    }, [data, currentPage, itemsPerPage]);

    const isAllSelected = currentPageData.every(item => selectedModules.includes(item.code));

    const columns = [
        { title: "Id", key: "id" },
        { title: "Código", key: "code" },
        { title: "Descripción", key: "name" },
        { title: "Seleccionar", key: "select" },
        
    ];

    const renderRow = (item, index) => (
        <>
            <td>{item.id}</td>
            <td>{item.code}</td>
            <td>{item.description}</td>
            <td >
                <input
                    type="checkbox"
                    checked={selectedModules.includes(item.code)}
                    onChange={() => handleCheckboxChange(item.code)}
                />
            </td>
        </>
    );

    return (
        isVisible && (
            <div className="modal-overlay">
                <div className="modal-content-module">
                    <div className="modal-content-module-body">
                        <h3 className="modal-title ">Permisos</h3>
                        <div className="filter-form">
                            <div className="basic-info-form-group">
                                <input
                                    type="text"
                                    id="customer"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    placeholder="Permiso"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleFresh();
                                        }
                                    }}
                                />
                            </div>
                            <button className="basic-custom-button" onClick={handleFresh}>
                                <FontAwesomeIcon icon={faSearch} className="basic-shortcut-icon" />
                                Buscar
                            </button>

                        </div>
                        <TableModule
                            title="Lista de Permisos"
                            rows={data}
                            columns={columns}
                            icon={faClipboardCheck}
                            renderRow={renderRow}
                            currentPage={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={setCurrentPage}
                            onRefresh={handleFresh}
                            onSelectAll={handleSelectAll}
                            isAllSelected={isAllSelected}
                            loading={loading}
                            select={true}
                        />

                    </div>
                    <div className="basic-form-footer">
                        <button
                            className="basic-custom-button"
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                            Cancelar
                        </button>
                        <button className="basic-custom-button" onClick={handleSave}>
                            <FontAwesomeIcon icon={faCheck} className="basic-shortcut-icon" />
                            Aceptar
                        </button>
                    </div>
                </div>
                <SuccessNotification
                    message={"Se ha cargado correctamente"}
                    isVisible={isSuccessVisible}
                    onClose={() => setIsSuccessVisible(false)}
                />
                <ErrorNotification
                    message="Ups! Ocurrió un Problema"
                    isVisible={isErrorVisible}
                    onClose={() => setIsErrorVisible(false)}
                />
            </div>

        )

    );
};

export default PermissionsModal;